import { render, staticRenderFns } from "./SpineExerciseVideoDetailPage.vue?vue&type=template&id=0ee54ec9&scoped=true"
import script from "./SpineExerciseVideoDetailPage.vue?vue&type=script&lang=js"
export * from "./SpineExerciseVideoDetailPage.vue?vue&type=script&lang=js"
import style0 from "./SpineExerciseVideoDetailPage.vue?vue&type=style&index=0&id=0ee54ec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee54ec9",
  null
  
)

export default component.exports